import { graphql } from "react-relay";
import "@components/invite-card/InviteCard.gql";
import "@components/copy-personal-invite-link-btn/CopyPersonalInviteLinkBtn.gql";

export const fragments = {
  viewer: graphql`
    fragment OnboardingOrgInvite_viewer on Viewer
    @argumentDefinitions(
      queryInput: { type: "String!", defaultValue: "" }
      orgRelayId: { type: "ID!", defaultValue: "" }
      excludeCalendars: { type: "[String]" }
    ) {
      user {
        ...CopyPersonalInviteLinkBtn_user
      }
    }
  `,
  org: graphql`
    fragment OnboardingOrgInvite_org on Org
    @argumentDefinitions(queryInput: { type: "String!", defaultValue: "" }) {
      id
      ...InviteCard_org
      ...CopyPersonalInviteLinkBtn_org
      experiments
      orgPersonListPaginatedErrorable(
        sortType: Status
        sortDirection: Ascending
        limit: 5
        searchQuery: $queryInput
      ) {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on OrgPersonListPaginated {
          inputQuery
          searchPersons {
            person {
              primaryCalendarId
              userId
              personId
              isYou
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
          }
        }
      }
      suggestedInvites(first: 1000000) {
        edges {
          node {
            id
            targetCalendarId
            targetProfile {
              givenName
              familyName
              externalImageUrl
            }
            resolution
            numberOfSharedMeetings
            numberOfOrganizedMeetings
            inviteReason
            totalScore
          }
        }
      }
      pendingInvites(first: 1000000) {
        edges {
          node {
            id
            targetCalendarId
            lastSentTime
            targetProfile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query OnboardingOrgInviteQuery($queryInput: String!, $orgRelayId: ID!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        orgPersonListPaginatedErrorable(
          sortType: Status
          sortDirection: Ascending
          limit: 5
          searchQuery: $queryInput
        ) {
          __typename
          ... on GraphEntityError {
            message
          }
          ... on OrgPersonListPaginated {
            inputQuery
            searchPersons {
              person {
                primaryCalendarId
                userId
                personId
                isYou
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getEventMeetingsQuery = graphql`
  query OnboardingOrgInviteEventQuery($orgRelayId: ID!, $week: LocalWeek!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        id
        calculateSmartHoldsErrorable(week: $week) {
          __typename
          ... on SmartHoldCalculationResult {
            events {
              title
              attendeePeople {
                __typename
                ... on PersonList {
                  list {
                    id
                    isUser
                    isYou
                    primaryEmail
                    profile {
                      givenName
                    }
                  }
                }
              }
              recurrenceRules {
                interval {
                  interval
                  freqType
                }
              }
            }
          }
        }
      }
    }
  }
`;
